<div *ngIf="loaded===1">

    <!--------------------------------------------------------------------------------------- BANNER VISIBLE EN ESCRITORIO UNICAMENTE -->
    <section class="backDark banner" fxShow="true" fxShow.lt-md="false">
        <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="300px">
            <img [src]=empresa.foto class="imgEmpresa">
            <div></div>
            <div fxLayout="column" fxLayoutAlign="center" class="zIndex1">
                <a (click)=regresarEmpresas() class="gray-3 cursorPointer" >Empresas <span class="ft10 gray-3">></span> </a>
                <div fxLayout="row" fxLayoutAlign=" center">
                    <h5 class="gray-1a mgb0 mgr10"> {{empresa.nombre}} </h5>
                    <a href="{{empresa.enlaceLinkedin}}" target="_blank">
                        <i class="fab fa-linkedin blueLink linkIcon ft20 pdt05"></i>
                    </a>
                </div>
                <h6 class="light-link-color ft300 ft16">{{empresa.resumen}}</h6>

                <div fxLayout="row">
                    <a href="{{empresa.sitioWeb}}" target="_blank">
                        <span class="mgt10 mgb10 chip gray-7 cursorPointer">{{empresa.sitioWeb}}</span>
                    </a>
                </div>

            </div>

        </div>
    </section>

    <!--------------------------------------------------------------------------------------- BANNER VISIBLE EN MOBILE UNICAMENTE -->
    <section class="backDark pdt30 pdb30" fxShow="false" fxShow.lt-md="true">

        <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" fxLayoutGap="300px"
            fxLayoutGap.lt-md="1rem">

            <div fxLayoutAlign="center" fxFlex="100%">
                <img [src]=empresa.foto class="avatarSquare10 radius10 shadow30 mgb10">
            </div>

            <div fxLayout="column" fxLayoutAlign="center center" class="zIndex1 w-80">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <h5 class="gray-1a mgb0 mgr10"> {{empresa.nombre}}</h5>
                </div>
                <h6 class="light-link-color ft300 ft16 centertext">{{empresa.resumen}}</h6>

                <div fxLayout="row">
                    <a href="{{empresa.sitioWeb}}" target="_blank">
                        <span class="mgt10 mgb10 chip gray-7 cursorPointer">{{empresa.sitioWeb}}</span>
                    </a>
                </div>
                <a href="{{empresa.enlaceLinkedin}}" target="_blank" class="mgt20">
                    <i class="fab fa-linkedin blueLink linkIcon ftxxl pdt05"></i>
                </a>
            </div>

        </div>
    </section>

    <!----------------------------------------------------------------------------------------->
    <!-- -------------------------------------------------------------------------------------->
    <!-- -----------------------------------INFO GENERAL -------------------------------------->
    <!----------------------------------------------------------------------------------------->
    <!-- -------------------------------------------------------------------------------------->

    <!-- ------------------------------------------------------------------------------------- COLUMNA IZQUIERDA  -->
    <section ngClass.gt-sm="pdt40" ngClass.lt-md="pdt20">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="4rem" fxLayoutGap.lt-md="1rem"
            fxLayout.lt-md="column" class="cw">

            <div fxFlex="50%">
                <h6 class="h6Title">Resumen de empresa</h6>
                <p>{{empresa.descripcion}}</p>

                <h6 class="h6Title">Instructores</h6>
                <div *ngFor="let item of instructoresEmpresa;  let i=index">
                    <div routerLink="/instructor/{{item.id}}" class="mgt10 pd08 pdr10 cursorPointer" fxLayout="row"
                        fxLayoutAlign="space-between" fxLayoutGap="2rem">
                        <div fxLayout="row" fxLayoutGap="1rem" fxFlex="100%">
                            <img [src]=item.foto class="avatar4">
                            <div>
                                <h6 class="ft13 ft500 mgt0 mgb0">
                                    {{item.nombre}}
                                </h6>
                                <p class="mgt0 mgb0 ft12">{{item.resumen}} </p>
                                <!-- <p class="mgt0 mgb0 ft12">{{item.data.cursos}} cursos </p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ------------------------------------------------------------------------------------- COLUMNA DERECHA  -->
            <div fxFlex="50%" fxLayout="column">

                <h6 class="h6Title">Cursos ofrecidos</h6>
                <div *ngFor="let item of cursosEmpresa;  let i=index">
                    <div routerLink="/curso/{{item.id}}" ngClass.gt-sm="mgt05 mgb10 border radius3"
                        ngClass.lt-md="mgt05 mgb10" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="2rem"
                        class="cursorPointer">
                        <div fxLayout="row" fxLayoutGap="1rem" fxFlex="90%" fxFlex.lt-md="100%">
                            <img [src]=item.foto class="avatarSquare10 radius3">
                            <div class="pdt08 pdb10">
                                <h6 class="ft13 ft500 mgt0 mgb0">
                                    {{item.titulo}}
                                </h6>
                                <p class="mgt0 mgb0 ft11">{{item.resumen}} </p>
                                <span class="ft500 gray-8" fxShow="false" fxShow.lt-md="true"> $
                                    {{item.precioFinal}}</span>
                            </div>
                        </div>
                        <div fxFlex="10%" fxLayoutAlign="end" class="pd08 mgr05" fxFlex=15% fxShow="true"
                            fxShow.lt-md="false">
                            <span class="ft500 gray-8"> $ {{item.precioFinal}}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</div>

<div *ngIf="loaded===0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>